import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelText as _vModelText, withCtx as _withCtx, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "relative z-10",
  "aria-labelledby": "modal-title",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 transition-opacity bg-gray-900 bg-opacity-75" }, null, -1)
const _hoisted_3 = { class: "fixed inset-0 z-10 overflow-y-auto" }
const _hoisted_4 = { class: "flex items-end justify-center min-h-full p-4 text-center sm:items-center sm:p-0" }
const _hoisted_5 = { class: "relative w-full overflow-hidden text-left transition-all transform bg-white rounded shadow sm:my-8 sm:w-full sm:max-w-lg" }
const _hoisted_6 = { class: "bg-white" }
const _hoisted_7 = { class: "flex items-center justify-between border-b border-gray-400" }
const _hoisted_8 = { class: "w-full px-2 py-4 text-left" }
const _hoisted_9 = {
  class: "text-lg font-medium leading-6 text-gray-900",
  id: "modal-title"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-x-lg",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z" })
], -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = ["onSubmit"]
const _hoisted_13 = { class: "mt-4 space-y-1" }
const _hoisted_14 = ["href"]
const _hoisted_15 = { class: "mt-4" }
const _hoisted_16 = { class: "mt-4 font-medium" }
const _hoisted_17 = { class: "mt-4" }
const _hoisted_18 = { class: "mt-2 font-medium" }
const _hoisted_19 = { class: "block mt-2 space-y-1" }
const _hoisted_20 = ["onUpdate:modelValue", "value"]
const _hoisted_21 = { class: "mt-4" }
const _hoisted_22 = { class: "block font-medium capitalize" }
const _hoisted_23 = { class: "flex justify-center px-4 pt-4 bg-gray-50" }

import { ref, watch, PropType, onUnmounted } from "vue";

import DefaultButton from "../DefaultButton.vue";

import api from "@/api/api";
import { useGlobalStore } from "@/store";
import { Goal } from "@/types";
import { formatDate } from "@/utils/dates";
import { goalCategories } from "@/utils/constants";
import capitalize from "@/utils/capitalize";


export default /*#__PURE__*/_defineComponent({
  __name: 'AddMemberGoalModal',
  props: {
  isOpen: {
    type: Boolean,
    required: true,
  },
  mode: {
    type: String,
    required: true,
  },
  isSavingGoal: {
    type: Boolean,
    required: true,
  },
  club_id: {
    type: Number,
    required: true,
  },
  member_id: {
    type: String,
    required: true,
  },
  goal: {
    type: Object as PropType<Goal | null>,
    required: false,
  },
},
  emits: ["close", "fetch"],
  setup(__props, { emit: emits }) {

const props = __props;

const website_url = process.env.VUE_APP_WEBSITE_URL;




const datepicker = ref();

const globalStore = useGlobalStore();

const isSavingGoal = ref(false);

const goal = ref({
  member_id: "",
  brick_club_id: 0,
  description: "",
  start_date: "",
  category: "",
  status: "",
});

function close() {
  emits("close");
}

function setGoalDate(date: Date) {
  if (!date) return;

  goal.value.start_date = formatDate(date);
  datepicker.value.closeMenu();
}

async function saveGoal() {
  if (props.mode === "create") {
    /** Create note */
    try {
      isSavingGoal.value = true;
      await api.goals.createGoal(props.club_id, props.member_id, {
        member_id: props.member_id,
        brick_club_id: props.club_id,
        start_date: goal.value.start_date,
        description: goal.value.description,
        category: goal.value.category,
        status: "active",
      });

      globalStore.toast("SUCCESS", "Member Goal created");
    } catch (error) {
      console.log(error);
      globalStore.toast("ERROR", "Error creating Member Goal");
    }
  }

  if (props.mode === "update") {
    /** Update existing note */
    try {
      isSavingGoal.value = true;
      await api.goals.updateGoal(props.club_id, props.member_id, props.goal!.id, {
        member_id: props.member_id,
        brick_club_id: props.club_id,
        start_date: goal.value.start_date,
        description: goal.value.description,
        category: goal.value.category,
        status: goal.value.status,
      });

      globalStore.toast("SUCCESS", "Member Goal updated");
    } catch (error) {
      console.log(error);
      globalStore.toast("ERROR", "Error updating Member Goal");
    }
  }

  isSavingGoal.value = false;

  return emits("fetch");
}

onUnmounted(() => {
  goal.value = {
    member_id: "",
    brick_club_id: 0,
    description: "",
    start_date: "",
    category: "",
    status: "",
  };
});

watch(
  () => props.isOpen,
  () => {
    if (props.isOpen && props.goal) {
      goal.value = props.goal;
    } else {
      goal.value = {} as Goal;
    }
  }
);

return (_ctx: any,_cache: any) => {
  const _component_DatePicker = _resolveComponent("DatePicker")!

  return (props.isOpen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("h3", _hoisted_9, _toDisplayString(_ctx.$t("add-a-goal")), 1)
                  ]),
                  _createElementVNode("div", { class: "py-4 pl-2 pr-4" }, [
                    _createElementVNode("button", { onClick: close }, _hoisted_11)
                  ])
                ]),
                _createElementVNode("form", {
                  class: "px-4 pb-4 mt-4 border-b border-gray-400",
                  onSubmit: _withModifiers(saveGoal, ["prevent"])
                }, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("p", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t("add-goal-modal-helptext")) + " ", 1),
                      _createElementVNode("a", {
                        href: _unref(website_url) + '/howto',
                        target: "_blank",
                        class: "text-blue-500 underline hover:text-blue-600"
                      }, _toDisplayString(_ctx.$t("learn-more")), 9, _hoisted_14)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t("date-you-set-this-goal")), 1),
                    _createVNode(_component_DatePicker, {
                      ref_key: "datepicker",
                      ref: datepicker,
                      modelValue: goal.value.start_date,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((goal.value.start_date) = $event)),
                      onInternalModelChange: _cache[1] || (_cache[1] = e => setGoalDate(e)),
                      required: "",
                      "enable-time-picker": false,
                      "max-date": new Date(),
                      format: "dd/MMM/yyyy",
                      onCleared: _cache[2] || (_cache[2] = ($event: any) => (goal.value.start_date = ''))
                    }, null, 8, ["modelValue", "max-date"])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t("category-of-goal")), 1),
                    _createElementVNode("div", _hoisted_19, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(goalCategories), (category, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "items-center space-x-2"
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            id: "category",
                            name: "social",
                            "onUpdate:modelValue": ($event: any) => ((goal.value.category) = $event),
                            value: category,
                            required: ""
                          }, null, 8, _hoisted_20), [
                            [_vModelRadio, goal.value.category]
                          ]),
                          _createElementVNode("label", null, _toDisplayString(_unref(capitalize)(_ctx.$t(category))), 1)
                        ]))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t("goal")), 1),
                    _withDirectives(_createElementVNode("textarea", {
                      class: "block w-full mt-1 border-gray-600 rounded-md shadow-sm focus:border-blue-300 focus:ring focus:ring-blue-200 focus:ring-opacity-50",
                      rows: "3",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((goal.value.description) = $event)),
                      required: ""
                    }, null, 512), [
                      [_vModelText, goal.value.description]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createVNode(DefaultButton, {
                      type: "primary",
                      "is-form-submit": true,
                      disabled: isSavingGoal.value,
                      loading: isSavingGoal.value
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("save")), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled", "loading"])
                  ])
                ], 40, _hoisted_12)
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})